<template>
  <div class="img-compress-en">
    <div class="header">
      <div class="con">
        <img class="logo" src="@/images/logo-en.png" alt="Content Adaptive JPEG Re-compression">
        <a class="right" @click="aboutModal = true">About us</a>
        <Modal
          v-model="aboutModal"
          title="About us">
          <p>Content Adaptive JPEG Re-compression</p>
          <div slot="footer"></div>
        </Modal>
      </div>
    </div>
    <div class="content">
      <div class="banner"></div>
      <!--提示-->
      <div class="hint">
        <span>* Please upload pictures in JPG and JPEG format</span>
      </div>
      <div class="tips">
        <span class="tipsImgOri">Original Image</span>
        <span class="tipsImgTrans">Compressed Image</span>
      </div>
      <div class="compare-box"
           @mouseover.prevent="imageCompareMouseMove($event)"
           @mousemove.prevent="imageCompareMouseMove($event)"
      >
        <template v-if="showSourceProgress">
          <Progress class="upload-progress" :percent="sourceProgress" :stroke-width="20" status="active" text-inside/>
        </template>
        <image-compare ref="imageCompare1" v-if="sourceProgress < 100 && !showSourceProgress" :before="exampleCompress" :after="exampleOriginal" :padding="{ left: 30, right: 30 }">
          <i class="fa fa-angle-left" aria-hidden="true" slot="icon-left"></i>
          <i class="fa fa-angle-right" aria-hidden="true" slot="icon-right"></i>
        </image-compare>
        <image-compare ref="imageCompare1" v-else-if="sourceProgress === 100 && !showCompressResult" :before="compressing" :after="compressing" :padding="{ left: 30, right: 30 }">
          <i class="fa fa-angle-left" aria-hidden="true" slot="icon-left"></i>
          <i class="fa fa-angle-right" aria-hidden="true" slot="icon-right"></i>
        </image-compare>
        <image-compare ref="imageCompare2" v-else-if="showCompressResult && sourceProgress === 100" :before="compress['compress_preview'] +''" :after="source['preview']" :padding="{ left: 30, right: 30 }">
          <i class="fa fa-angle-left" aria-hidden="true" slot="icon-left"></i>
          <i class="fa fa-angle-right" aria-hidden="true" slot="icon-right"></i>
        </image-compare>
      </div>
      <!--压缩盒子
      <div class="face-box">
        <div class="img-box">
          <div class="img-box-inner">
            <template v-if="showSourceProgress">
              <Progress class="upload-progress" v-if="sourceProgress < 100" :percent="sourceProgress"
                        :stroke-width="5"/>
              <Progress class="upload-progress" v-else :percent="100" :stroke-width="5">
                <span>Processed</span>
              </Progress>
            </template>
            <pr-image-responsive v-if="showSource"
                                 :preview="true"
                                 :url="source['preview']"/>
            <pr-image-responsive v-if="sourceProgress <= 0"
                                 :preview="true"
                                 :url="exampleOriginal"/>
          </div>
          <div class="img-remove" v-show="showSourceProgress || showSource">
            <Icon type="md-close" size="30" color="#93fcfc" @click="removeSource"/>
          </div>
        </div>
        <div class="img-box">
          <div class="img-box-inner">
            <pr-image-responsive v-if="showCompress"
                                 :preview="true"
                                 :url="compress['compress_preview']"/>
            <pr-image-responsive v-else
                                 :preview="true"
                                 :url="exampleCompress"/>
          </div>
        </div>
      </div>
      v-if="!showSource" v-show="!showSourceProgress"
      -->
      <!--操作按钮-->
      <div class="prompt">
        <div class="btn">
            <pr-upload-en ref="source"
                          @fileChange="sourceChange"
                          @beforeUpload="sourceBeforeUpload"
                          @uploading="sourceUploading"
                          @uploaded="sourceUploaded"
                          @errorFormat="sourceErrorFormat"
                          :progress="false"
                          :url="uploadUrl"
                          :maxSize="maxSize"
                          :format="['jpg','jpeg','JPG','JPEG','jPG','jpG']"></pr-upload-en>
          <div class="start" v-if="showCompress">
            <Button type="primary" @click="doCompress" :loading="isLoading" disabled>
              <span v-if="!isLoading">Start compression</span>
              <span v-else>Processed...</span>
            </Button>
          </div>
          <div class="start" v-else>
            <Button type="primary" @click="doCompress" :loading="isLoading">
              <span v-if="!isLoading">Start compression</span>
              <span v-else>Processed...</span>
            </Button>
          </div>
        </div>
      </div>
      <!--结果集-->
      <div class="info">
        <p class="oriInfo">
          <span class="info-title">Original Image (JPG)</span>
          <Progress :percent="100" hide-info />
          <span class="info-txt">{{beforeSize}}</span>
        </p>
        <p class="transInfo">
          <span class="info-title">Compressed Image (JPG)</span>
          <Progress :percent="compressRatio" hide-info />
          <span class="info-txt">{{afterSize}}</span>
          <a v-if="showCompress" @click="download(compress['compress_download'])" title="download images" target="blank" >
            <Icon type="md-download" />
          </a>
        </p>
        <!--压缩品质-->
        <p class="choice">
          <span class="info-title" style="width: 100px;">Quality：</span>
          <RadioGroup v-model="mode" @on-change="modeChange" size="large">
            <Radio :label="0">high</Radio>
            <Radio :label="1">medium</Radio>
            <Radio :label="2">low</Radio>
          </RadioGroup>
        </p>
      </div>
      <div class="component">
        <number-scroll-component v-bind:total=counterNum></number-scroll-component>
        <p>The number of optimized pictures currently uploaded</p>
      </div>
    </div>
    <div class="footer">
      <footer>
        <div class="contact">
          <p>Contact us</p>
          <p>Email:<a href="mailto:contact@solandtech.com">contact@solandtech.com</a></p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import PrUploadEn from '../components/PrUploadEn';
import PrImageResponsive from '../components/PrImageResponsive';
import LoadingStatus from '../components/LoadingStatus';
import VueImageCompare from 'vue-image-compare';
import NumberScrollComponent from "../components/NumberScrollComponent";

export default {
  name: 'img-compress-en',
  components: {
    PrUploadEn,
    PrImageResponsive,
    LoadingStatus,
    VueImageCompare,
    NumberScrollComponent
  },
  data() {
    return {
      // 文件大小
      maxSize: 10240000,
      uploadUrl: 'https://www.solandtech.com/api/v1/upload/file',
      readCounterUrl: 'https://www.solandtech.com/api/v1/counter/read',
      updateCounterUrl: 'https://www.solandtech.com/api/v1/counter/update',
      showSource: false,
      source: {},
      showSourceProgress: false,
      sourceProgress: 0,
      showCompress: false,
      compress: {},
      loadingText: '',
      isLoading: false,
      compressResult: [],
      showCompressResult: false,
      // 压缩模式
      mode: 0,
      // 压缩请求取消
      compressCancel: null,
      // 原始文件名
      fileName: '',
      beforeSize: '107.5KB',
      afterSize: '37KB',
      compressRatio: 2.9,
      isAbailable: false,
      aboutModal: false,
      exampleOriginal: require('@/images/example.jpeg'),
      exampleCompress: require('@/images/exampleCompress.jpeg'),
      compressing: require('@/images/compressing.jpeg'),
      counterNum: 0
    };
  },
  methods: {
    imageCompareMouseMove(event) {
      //console.log(event);
      let compare;
      if (this.sourceProgress < 100 && !this.showSourceProgress) {
        compare = this.$refs['imageCompare1'];
      }else if (this.sourceProgress === 100 && !this.showCompressResult){
        compare = this.$refs['imageCompare1'];
      } else {
        compare = this.$refs['imageCompare2'];
      }
      compare.onMouseMove(event, true);
    },
    //查询计数器
    getCounter(){
      axios({
        method: 'get',
        url: this.readCounterUrl
      }).then(resp => {
        const dataRes = resp['data'];
        if (dataRes['code'] === 200) {
          // 赋值到表单
          //console.log(dataRes['data'].num)
          this.counterNum = dataRes['data'].num;
        }
      })
    },
    //更新计数器操作
    updateCounter(){
      axios({
        method: 'post',
        url: this.updateCounterUrl
      }).then(resp => {
        const dataRes = resp['data'];
        if (dataRes) {
          if (dataRes['code'] !== 200) {
            this.$Message.error({
              content: 'counter update failure ！',
              duration: 5,
              closable: true
            })
          }
        }
      })
    },
    sourceChange(files) {
      if (files && files.length === 1) {
        this.source = files[0];
        // 执行压缩
        this.doCompress();
        this.showSource = true;
      } else {
        this.source = {};
        this.showSource = false;
      }
    },
    // 上传之前
    sourceBeforeUpload() {
      this.showSourceProgress = true;
    },
    // 上传进度
    sourceUploading(event) {
      this.sourceProgress = Math.round(event.percent * 100) / 100;
      this.fileName = this.$refs['source'].fileName;
    },
    // 上传进度
    sourceUploaded() {
      this.showSourceProgress = false;
    },
    // 错误格式
    sourceErrorFormat() {
      this.showSourceProgress = false;
    },
    modeChange() {
      if (!this.source['preview'] || this.source['preview'] === '') {
        return;
      }
      // 执行压缩
      this.doCompress();
    },
    removeSource() {
      this.source = {};
      this.showSource = false;
      this.sourceProgress = 0;
      this.showSourceProgress = false;
      if (typeof this.compressCancel === 'function') {
        this.compressCancel();
      }
      this.clearResult();
      // 取消上传
      if (this.$refs['source']) {
        this.$refs['source'].cancelUpload();
      }
    },
    // 清除压缩结果
    clearResult() {
      this.compress = {};
      this.showCompress = false;
      this.loadingText = '';
      this.showCompressResult = false;
      this.compressResult = [];
    },
    // 开始压缩
    doCompress() {
      //更新一次计数器
      this.updateCounter()
      if (typeof this.compressCancel === 'function') {
        this.compressCancel();
      }
      // 压缩前清除之前的压缩记录
      this.clearResult();
      if (!this.source['preview'] || this.source['preview'] === '') {
        this.$Message.error({
          content: 'Please upload a picture !',
          duration: 10,
          closable: true
        });
        return;
      }
      this.loadingText = 'Processed...';
      this.isLoading = true;
      axios({
        url: this.source['compress'] + '?mode=' + this.mode,
        cancelToken: new axios.CancelToken((c) => {
          this.compressCancel = c;
        })
      }).then(resp => {
        const dataRes = resp['data'];
        this.isLoading = false;
        if (dataRes && dataRes['code'] === 200) {
          if (dataRes['data']['compress_ratio'] === '0.000%') {
            this.$Message.warning({
              content: 'The picture may have been compressed, please replace !',
              duration: 5,
              closable: true
            });
            this.loadingText = 'Compression failure !';
          } else {
            this.compress = dataRes['data'];
            this.showCompress = true;
            this.loadingText = dataRes['data']['compress_ratio'] + '<br>压缩率';
            this.beforeSize = dataRes['data']['before_compress_size_format'];
            this.afterSize = dataRes['data']['after_compress_size_format'];
            this.compressRatio = (dataRes['data']['after_compress_size'] / dataRes['data']['before_compress_size']) * 100;
            this.showCompressResult = true;
            //重新获取计数器数据
            this.getCounter()
          }
        } else {
          this.compress = {};
          this.showCompress = false;
          this.loadingText = 'Compress Error';
        }
      }).catch((error) => {
        this.isLoading = false;
        const response = error['response'];
        const message = error['message'];
        if (axios.isCancel(error)) {
          this.loadingText = '';
          return;
        }
        if (message === 'Network Error') {
          this.$Message.error({
            content: 'Network Error',
            duration: 5,
            closable: true
          });
          this.loadingText = 'Compress Error';
        } else if (response) {
          const dataRes = response['data'];
          if (dataRes && (dataRes['code'] === 400 || dataRes['code'] === 500)) {
            this.$Message.error({
              content: dataRes['msg'],
              duration: 5,
              closable: true
            });
          }
        }
        this.loadingText = 'Compress Error';
      });
    },
    // 获取画质
    getQuality(mode) {
      switch (mode) {
        case 0:
          return '高保真, 压缩率低';
        case 1:
          return '相似度, 压缩率适中';
        case 2:
          return '相似度低, 压缩率高';
      }
    },
    download(imgSrc) {
      if (imgSrc && imgSrc !== '') {
        window.location.href = imgSrc;
      } else {
        this.$Message.warning({
          content: '请先压缩图片',
          duration: 5,
          closable: true
        });
      }
    }
  },
  destroyed() {
    if (typeof this.compressCancel === 'function') {
      this.compressCancel();
    }
  },
  created() {
    this.getCounter()
  }
};
</script>

<style lang="less" scoped>
  //@import "https://cdnjs.cloudflare.com/ajax/libs/bulma/0.2.1/css/bulma.min.css";
  @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css";
  .img-compress-en {
    width: 100%;

    .header {
      display: flex;
      flex-wrap: nowrap;
      width: 100%;
      height: 70px;
      //background:linear-gradient(270deg,rgba(148,186,250,1),rgba(30,74,163,1));
      background-color: #2F2F2F;

      .con {
        width: 1000px;
        height: 100%;
        margin: auto !important;

        .logo {
          height: 70px;
          width: 70px;
        }

        .right {
          float: right;
          line-height: 70px;
          font-size: 20px;
          font-family: Blacker Text;
          color: rgba(255, 255, 255, 1);
        }
      }
    }

    .content {
      width: 1000px;
      //height: 630px;
      margin: auto !important;

      .choice {
        height: 50px;

        .btn-group {
          margin-top: 20px;
          font-size: 20px;
        }
      }
    }

    .component {
      margin: 0 auto 30px;
      text-align: center;
      p {
        font-family: Blacker Text;
        font-size: 16px;
        color: #464545;
      }
    }
  }

  .background {
    background: url(" ") no-repeart 0 0 !important;
  }

  .footer {
    width: 100%;
    background-color: #061023;
    color: rgba(255, 255, 255, 1);

    .content {
      margin-top: 10px;
    }
  }

  footer {
    position: relative;
    width: 1000px;
    height: 140px;
    margin: auto;
    padding: 10px;

    p {
      font-size: 16px;
      font-family: Blacker Text;
      font-weight: 300;
      margin-top: 10px;
    }
  }

  .hint {
    margin-bottom: 10px;
    height: 30px;
    font-size: 18px;
  }

  .tips {
    height: 30px;
    span {
      height:30px;
      opacity:0.4;
      font-size:16px;
      font-family:Blacker Text;
      font-weight:bold;
      color:rgba(0,0,0,1);
      z-index: -1;
    }
    .tipsImgOri {
      float: left;
    }
    .tipsImgTrans {
      float: right;
    }
  }

  .compare-box {
    min-height: 400px;
    width: 1000px;
    //border:2px solid rgba(174,174,174,1);
    border: 2px dashed rgba(174, 174, 174, 1);
    padding: 1px;
    .ivu-progress {
      margin-top: 175px !important;
    }
  }

  .banner {
    height:25px;
    margin: 30px 0 30px 0;
    background: url("~@/images/banner.png") no-repeat  center;
  }

  // 演示主体部分
  .demos-box {
    padding: 20px 0;
    font-size: 15px;
  }

  .info {
    margin: 15px 0 40px 0;
    text-align: left;
    .ivu-progress {
      width:40%;
    }
    p {
      height: 40px;
      line-height: 50px;
      //position: relative;
    }
    .oriInfo {
      //position: relative;
      z-index: -1;
    }
    .info-title {
      display: inline-block;
      color: #464545;
      width: 215px;
      font-size:16px;
      font-family:Blacker Text;
      font-weight:bold;
    }
  }

  // 底部提示
  .prompt {
    margin-top: 10px;
    font-size: 20px;

    .btn {
      float: right;
      display: flex;
      margin-top: 15px;
      z-index:100;
      .start {
        margin-left: 10px;
      }
    }
  }

  // 图片
  .img-box {
    width: 495px;
    height: 405px;
    //background: url("~@/images/example.png") no-repeart;
    border: 2px dashed rgba(174, 174, 174, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .img-remove, .img-down {
      position: absolute;
      top: 0;
      right: 0;

      .ivu-icon {
        cursor: pointer;
      }
    }
  }

  .img-box-inner {
    width: 495px;
    height: 405px;
    //box-shadow: 0 0 32px rgba(0, 255, 255, 0.35) inset;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // 上传组件
  .ivu-upload-drag {
    background-color: transparent;
    border: none;

    &:hover {
      border: none;
    }
  }

  // 比对之后结果显示
  .after-comparison {
    width: 1000px;
    height: 95px;
    padding: 5px;
    margin-top: 20px;
    border: 2px solid #C2CAC7;

    .inner {
      ul {
        margin: 0;
        padding: 0;
      }

      li {
        display: block;
        margin: .4rem;
        padding: 0 .5rem;
        background: #f0f0f0;
        border: .1rem solid #cfdbde;
        border-radius: .2rem;
        font-weight: bold;
        line-height: 2.8rem;
        color: #363a43;
        height: 3rem;

        .before {
          padding: 0 6.4rem 0 0;

          .size {
            float: right;
            margin-left: .8rem;
            margin-right: -5.600000000000001rem;
          }
        }

        .progress {
          margin: -.1rem;
          padding: .3rem;
          border: .1rem solid #cfdbde;
          border-radius: 1.5rem;
          background-color: #fff;
          height: 3rem;
          transform: translateZ(0);

          .bar {
            //background-color: #92ed14;
            background: linear-gradient(270deg, rgba(68, 167, 243, 1), rgba(48, 115, 230, 1));
            animation: none;
            min-width: 2.2rem;
            width: 100%;
            height: 100%;
            border-radius: 1.1rem;;
          }

          .bar:after {
            content: "Compression success";
            position: absolute;
            margin: 0;
            width: 100%;
            height: 100%;
            padding: .5rem 0;
            font-size: 1rem;
            font-weight: normal;
            text-align: center;
            opacity: .9;
            line-height: 1em;
            color: #ffffff;
          }
        }

        .after {
          padding: 0 0 0 .8rem;
          text-align: right;

          .size {
            float: left;
            margin-right: .8rem;
          }

          a {
            color: #363a43;
            text-decoration: underline;
            cursor: pointer;
          }

          .saved {
            display: inline-block;
            margin-left: 1.6rem;
            width: 4rem;
          }
        }

        .size {
          display: block;
          width: 5.600000000000001rem;
          color: #44A7F3;
          font-size: 1.3rem;
          font-weight: normal;
          padding-top: .1rem;
          text-align: right;
          line-height: 2.7rem;
        }

        .before, .progress, .after {
          width: 33.33%;
          box-sizing: border-box;
          float: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .title {
      font-size: 14px;
      font-family: Blacker Text;
      font-weight: bold;
      color: rgba(20, 24, 35, 1);
    }

    .detail {
      .before {
        width: 33.33%;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        float: left;
        white-space: nowrap;
        overflow: hidden;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
      }

      .size {
        float: right;
        margin-left: .8rem;
        margin-right: -5.600000000000001rem;
      }

      .progress {
        margin: -.1rem;
        padding: .3rem;
        border: .1rem solid #cfdbde;
        border-radius: 1.5rem;
        background-color: #fff;
        height: 3rem;
        transform: translateZ(0);
        width: 33.33%;
        box-sizing: border-box;
        float: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .bar {
        background-color: #92ed14;
        animation: none;
        background-image: none;
        width: 100%;
        min-width: 2.2rem;
        height: 100%;
        border-radius: 1.1rem;
        background-size: 4.8rem 2.2rem;
      }

      .after {
        padding: 0 0 0 .8rem;
        text-align: right;
        width: 33.33%;
        box-sizing: border-box;
        float: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .face-box {
    display: flex;
    justify-content: space-between;
    position: relative;

    .loading-box {
      width: 280px;
      height: 280px;

      .ivu-btn {
        background: transparent;
        border: none;
        color: #93fcfc;
        font-size: 30px;
        z-index: 20;
        left: 65px;

        &:focus {
          box-shadow: none;
        }
      }
    }
  }

  .ivu-icon, .ivu-icon-md-close {
    color: rgb(174, 174, 174) !important;
  }

</style>
